import { Link } from 'react-router-dom';

export default function NotFound() {
    return (
        <div className="flex flex-col items-center text-gray-500">
            Page not found.
            <Link to="/overview" className="underline font-bold">
                Go back home
            </Link>
        </div>
    );
}
